import { ActionTypes } from './constants'

const initialState = {
    data: [],
    tblDataLoading: false
};

const mgtSensorDataReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.SET_DATA:
            return { ...state, data: payload }
        case ActionTypes.SET_TBL_DATA_LOADING:
            return { ...state, tblDataLoading: payload ? payload : !state.tblDataLoading }
        case ActionTypes.UPDATE_DATA:
            return {
                ...state,
                data: state.data.map((item) =>
                  item.id == payload.id ? {...item, raw_data: payload.raw_data, proc_data: payload.proc_data} : item
                ),
              };
        default:
            return state;
    }
};

export default mgtSensorDataReducer;